<div *ngIf="total == 0" class="issues-donut-no-actions">{{noDataText}}</div>
<div class="issues-donut-graph" [attr.width]="width" [attr.height]="height">
  <canvas #graphDonut [attr.width]="width" [attr.height]="height"></canvas>
  <div class="issues-donut-total-container">
    <p *ngIf="total !== 0 && !isLabelsDisplay" class="issues-donut-total">{{total}}</p>
  </div>
</div>
<div class="issues-donut-graph-legend" #graphLegend></div>